function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { cloner } from "../Cloner/Cloner";
var _createListItemFromTreeItem = /*#__PURE__*/new WeakMap();
class TreeFactory {
  constructor() {
    _defineProperty(this, "create", (list, parentId = null) => {
      const tree = [];
      const sameLevelItems = list.filter(item => item.parentId === parentId);
      sameLevelItems.forEach(item => {
        const children = this.create(list, item.id);
        const newItem = {
          ...item
        };
        newItem.children = children;
        tree.push(newItem);
      });
      return tree;
    });
    _defineProperty(this, "createListFromTree", (tree, labelProperty, depthPrefix = '', depth = 0) => {
      let list = [];
      if (!tree.length) {
        return list;
      }
      tree.forEach(item => {
        const newItem = _classPrivateFieldGet(_createListItemFromTreeItem, this).call(this, item, labelProperty, depthPrefix, depth);
        const subList = this.createListFromTree(item.children, labelProperty, depthPrefix, depth + 1);
        list.push(newItem);
        list = list.concat(subList);
      });
      return list;
    });
    _classPrivateFieldInitSpec(this, _createListItemFromTreeItem, (treeItem, labelProperty, depthPrefix, depth) => {
      const depthPrefixes = Array(depth).fill(depthPrefix).join('');
      const newlabel = `${depthPrefixes} ${treeItem[labelProperty]}`.trim();
      const item = {
        ...treeItem
      };
      delete item.children;
      item[labelProperty] = newlabel;
      return item;
    });
  }
}
const treeFactory = new TreeFactory();
export { treeFactory };